import React, { Component } from 'react'

class Buddiesnotes extends Component {
    constructor(props) {
        super(props)

    }


    componentDidMount () {

    }

    render () {
        return (
            <div className="buddies-lr1">
            <h2 className="bluetxt seek-head">Buddies</h2>
            
                <div id="divSharedlr"></div>
         
            

            </div>
        )
    }
}

export default Buddiesnotes


// WEBPACK FOOTER //
// ./src/lr_dlr_components/notepad_partials/Buddiesnotes.js